import { useToast } from 'vue-toastification'
import { useI18n } from 'vue-i18n'

export function useNotifications() {
  const toast = useToast()
  const { t } = useI18n()

  const showSuccess = (message, options = {}) => {
    toast.success(message, {
      icon: '✅',
      ...options
    })
  }

  const showError = (message, options = {}) => {
    toast.error(message, {
      icon: '❌',
      ...options
    })
  }

  const showWarning = (message, options = {}) => {
    toast.warning(message, {
      icon: '⚠️',
      ...options
    })
  }

  const showInfo = (message, options = {}) => {
    toast.info(message, {
      icon: 'ℹ️',
      ...options
    })
  }

  const showCopySuccess = (itemType = null) => {
    const translatedItemType = itemType || t('notifications.defaultItem')
    showSuccess(t('notifications.copied', { itemType: translatedItemType }), {
      timeout: 2000,
      icon: '📋'
    })
  }

  const showCopyError = () => {
    showError(t('notifications.copyFailed'), {
      timeout: 3000
    })
  }

  const copyToClipboard = async (text, itemType = null, buttonElement = null) => {
    try {
      await navigator.clipboard.writeText(text)
      showCopySuccess(itemType)
      
      // Add visual feedback to the button that was clicked
      if (buttonElement && buttonElement.classList) {
        buttonElement.classList.add('copy-success')
        setTimeout(() => {
          buttonElement.classList.remove('copy-success')
        }, 600)
      }
      
      return true
    } catch (error) {
      console.error('Failed to copy to clipboard:', error)
      showCopyError()
      return false
    }
  }

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showCopySuccess,
    showCopyError,
    copyToClipboard
  }
}